const authentication = require('../../react-azure-adb2c2').default;
export const rentMMedeasList = (values: any) => {


    const url = process.env.REACT_APP_API_BASE_URL + `/api/rentMMedeas/`;

    const token = authentication.getAccessToken();
    //const search = values ? values : {};


    return fetch(url, {
        headers: { 'Authorization': 'Bearer ' + token }
    })
        .then(res => (res.json()))
        .catch(error => ({ error }));
}
